module.exports = __webpack_public_path__ + "img/sample02.3924e678.jpg";